module.exports = __webpack_public_path__ + "img/education.36a1f18e.svg";